import makeApiCall from "../master/axiosIndex";

interface PortfolioSnapshotParams {
  date?: string;
  orgIds?: string;
  siteIds?: string;
  projectIds?: string;
  contractorIds?: string;
  workOrderIds?: string;
  raBillIds?: string;
  startDate?: string;
  endDate?: string;
  invoiceStartDate?: string;
  invoiceEndDate?: string;
  limit?: number;
  offset?: number;
  isExcelExport?: boolean;
  type?: string;
}

const controlTowerApis = {
  getPortfolioSnapshot: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/portfolio-snap-shot",
      method: "get",
      params,
    });
  },
  getProjectLevelRisk: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/project-level-risk",
      method: "get",
      params,
    });
  },
  getMaterialDelay: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/material-delay",
      method: "get",
      params,
    });
  },
  getReworkRequirements: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/rework-requirements",
      method: "get",
      params,
    });
  },
  getPaymentLag: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/payment-lag",
      method: "get",
      params,
    });
  },
  getResourceConstraints: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/resource-constraints-details",
      method: "get",
      params,
    });
  },
  getProcurementExecutiveView: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/procurement/executive-view",
      method: "get",
      params,
    });
  },
  getProcurementRiskRegister: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/procurement/procurement-risk-register",
      method: "get",
      params,
    });
  },
  getInvoicePayable: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/procurement/invoice-payable",
      method: "get",
      params,
    });
  },
  getTaskImpact: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/procurement/task-impact",
      method: "get",
      params,
    });
  },
  getWorkOrderImpact: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/procurement/work-order-impact",
      method: "get",
      params,
    });
  },
  getTopRiskMaterials: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/procurement/top-risk-materials",
      method: "get",
      params,
    });
  },
  getWorkOrderExecutiveSummary: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/executive-summary",
      method: "get",
      params,
    });
  },
  getExecutionPerformance: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/execution-performance",
      method: "get",
      params,
    });
  },
  getRABillLifecycle: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/rabill-lifeCycle",
      method: "get",
      params,
    });
  },
  getPaymentOutstandingAnalysis: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/payment-outstanding-analysis",
      method: "get",
      params,
    });
  },
  getRetentionExposureRegister: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/retention-exposure-register",
      method: "get",
      params,
    });
  },
  getWorkOrderCostVsBudgetPerformance: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/work-order-cost-Vs-budget-performance",
      method: "get",
      params,
    });
  },
  getExecutiveSummaryBudget: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/budget/executive-summary-budget",
      method: "get",
      params,
    });
  },
  getProjectWiseSummary: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/budget/project-wise-summary",
      method: "get",
      params,
    });
  },
  getBudgetTimelineUtilizationGraph: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/budget/budget-time-line-utilization-graph",
      method: "get",
      params,
    });
  },
  getProjectLevelFinancialRisk: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/budget/project-level-financial-risk",
      method: "get",
      params,
    });
  },
  getExecutiveInsights: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/budget/executive-insights",
      method: "get",
      params,
    });
  },
  getProjectWiseBudgetSummary: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/budget/project-wise-budget-distribution",
      method: "get",
      params,
    });
  },
  // subreports
  getTaskLevelRisk: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/project/task-wise-interlinking",
      method: "get",
      params,
    });
  },
  getWOMRiskInterlinking: (params?: PortfolioSnapshotParams): Promise<any> => {
    return makeApiCall<any>({
      url: "/control-tower-dashboard/wom/risk-InterLinking-automated-Mitigation",
      method: "get",
      params,
    });
  },
};

export default controlTowerApis;
